export default __webpack_public_path__ + "ccd3e26c750231f45a2d99e9a89e6389.png";